import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, XCircle, Info, X } from "lucide-react";
import { subscribeToasts, dismissToast } from "../utils/toast";

// Renders the toasts raised through utils/toast.js. Mounted once in Layout.
// Top-right on desktop (clear of the bottom-right upload widget), bottom on a
// phone where a thumb can reach the close button.

const STYLE = {
  success: { cls: "border-success-200", icon: CheckCircle2, iconCls: "text-success-600" },
  info: { cls: "border-line", icon: Info, iconCls: "text-ink-muted" },
  warning: { cls: "border-warning-300", icon: AlertTriangle, iconCls: "text-warning-600" },
  error: { cls: "border-danger-300", icon: XCircle, iconCls: "text-danger-600" },
};

export default function Toaster() {
  const [items, setItems] = useState([]);
  useEffect(() => subscribeToasts(setItems), []);

  return (
    <div
      className="fixed z-toast inset-x-3 bottom-3 sm:inset-x-auto sm:bottom-auto sm:top-16 sm:right-4 sm:w-96 flex flex-col gap-2 pointer-events-none"
      aria-live="polite"
    >
      {items.map((t) => {
        const s = STYLE[t.kind] ?? STYLE.info;
        const Icon = s.icon;
        return (
          <div
            key={t.id}
            role={t.kind === "error" || t.kind === "warning" ? "alert" : "status"}
            className={`pointer-events-auto flex items-start gap-2.5 bg-surface border ${s.cls} rounded-lg shadow-lg px-3.5 py-3 animate-toast-in`}
          >
            <Icon className={`w-5 h-5 shrink-0 mt-px ${s.iconCls}`} aria-hidden="true" />
            <p className="flex-1 text-sm text-ink whitespace-pre-line break-words">{t.message}</p>
            <button
              type="button"
              onClick={() => dismissToast(t.id)}
              className="shrink-0 -m-1.5 p-1.5 rounded text-ink-muted hover:text-ink hover:bg-surface-inset focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
              aria-label="Dismiss notification"
            >
              <X className="w-4 h-4" aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
